export const Unauthorized = () => {
    return (
        <div>
        <h1>Unauthorized</h1>
        <p>You are not authorized to view this page.</p>
        </div>
    );
}